module.exports = __webpack_public_path__ + "static/media/IMG-14.31cd032b.jpg";